import { render, staticRenderFns } from "./mallFinished.vue?vue&type=template&id=031a2e58&scoped=true&"
import script from "./mallFinished.vue?vue&type=script&lang=js&"
export * from "./mallFinished.vue?vue&type=script&lang=js&"
import style0 from "./mallFinished.vue?vue&type=style&index=0&id=031a2e58&prod&lang=less&scoped=true&"
import style1 from "./mallFinished.vue?vue&type=style&index=1&id=031a2e58&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a2e58",
  null
  
)

export default component.exports